import React, { ComponentType, ReactNode } from 'react'
import { Theme } from 'src/ui/style/Theme'
import { View } from 'src/ui/basic/View'
import { centeredContent } from 'src/ui/style/mixins/layout'
import { css } from 'src/ui/style/css'

export type LimitedWidthContainerProp = {
    children: ReactNode
    className?: string
    maxWidth?: string
}

const gtmClassName = 'limited-width-container'

export const LimitedWidthContainer: ComponentType<
    LimitedWidthContainerProp
> = ({ children, className, maxWidth }) => (
    <View
        className={[gtmClassName, className].filter(Boolean).join('-')}
        css={(th: Theme) => [
            centeredContent()(th),
            maxWidth &&
                css`
                    max-width: ${maxWidth};
                `
        ]}
    >
        {children}
    </View>
)
